export const ROLES = {
  admin: 2,
  user: 5,
};
